import { FC } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  SxProps,
  Typography,
  TypographyProps,
} from "@mui/material";
import ModalComponentsStyle from "./ModalComponentsStyle";
import muiVariables from "../../styles/mui-variables";

export interface ModelProps {
  open: boolean;
  handleClose?: () => void;
  children?: any;
  sx?: object;
  title?: string;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  titleStyle?: React.CSSProperties;
  modelPadding?: string;
  modelTitleTopPadding?: string;
}

const ModelComponents: FC<ModelProps> = ({
  open,
  handleClose,
  children,
  sx,
  title,
  maxWidth = "xs",
  titleStyle,
  modelPadding,
  modelTitleTopPadding,
  ...props
}) => {

  const dialogTitleTypography = {
    fontWeight: "700",
    padding: 0,
    fontSize: "20px",
    align: "center",
    color:
      title?.includes("Delete") || title?.includes("Eliminar") ||
        title?.includes("Archive Product") ||
        title?.includes("Deactivate resident")
        ? `${muiVariables.deleteTextColor}`
        : `${muiVariables.mainTextColor}`,
    fontFamily: muiVariables.mainFontFamily,
    ...titleStyle,
  } as TypographyProps;

  const dialogTitle = { p: modelTitleTopPadding ? modelTitleTopPadding : "3px 8px 32px 8px" } as SxProps;

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={maxWidth}
        fullWidth
        sx={{
          ...ModalComponentsStyle.dialogSx,
          ".MuiDialog-paper": {
            maxWidth:
              maxWidth === "md" ? "804px !important" : "440px !important",
            borderRadius: "12px",
          },
          ".MuiPaper-rounded": {
            padding: modelPadding
              ? modelPadding
              : { xs: "24px 16px", sm: "32px 40px 24px 40px" },
          },
        }}
        {...props}
      >
        <DialogTitle sx={dialogTitle}>
          <Typography {...dialogTitleTypography}>{title}</Typography>
        </DialogTitle>
        <DialogContent>{children}</DialogContent>
      </Dialog>
    </div>
  );
};

export default ModelComponents;
